module.exports = __webpack_public_path__ + "img/5.6cb56a5c.png";